import React from "react";
import { Card, Divider, Button } from "antd";
import { FaStar } from "react-icons/fa";



const ReviewHistoryCard = (props) => {
  const { name, reviewPeriod, overallRating, reviewDate, reviewedBy } = props;
  const ratings = [
    { criteria: "Attitude", evaluation: "Exceeds" },
    { criteria: "Communication", evaluation: "Meets" },
    { criteria: "Adaptability", evaluation: "Developing" },
    { criteria: "Problem Solving", evaluation: "Needs Focus" },
  ];
  return (

    <Card className="flex flex-col rounded-2xl border border-green-200 shadow-sm ">
      <div className="flex items-start justify-between gap-4 text-lg">
        <span className="absolute items-center right-5 px-3 py-1">
          <div className="flex items-center space-x-2 text-gray-900">
              <FaStar className="text-yellow-500 w-5 h-5"/>
              <span className="font-semibold">{overallRating}</span>
          </div>
            <span className="flex text-gray-500 text-sm">Overall Rating</span>
        </span>
        <div>
          <h4 className="font-semibold text-gray-800">{name}
            <span className="text-xs mx-2 border status-indicator completed">Completed</span>
          </h4>
          
          <div className="flex items-center text-gray-600 text-sm">
            Review Period: {reviewPeriod}
          </div>
        </div>
      </div>

  <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />
    <div className="grid grid-cols-2 gap-4 text-lg">
        <div>
          <div className="flex items-center text-gray-600">
            Review Date
          </div>
          <h4 className="font-semibold text-gray-800">{reviewDate}</h4>
        </div>
        <div>
          <div className="flex items-center text-gray-600">
            Reviewed By
          </div>
          <h4 className="font-semibold text-gray-800">{reviewedBy}</h4>
        </div>
    </div>
    <div className="flex gap-2 my-2">
      {ratings.map(({ criteria, evaluation }) => (
        <div key={criteria} className="flex flex-col gap-1">
          <span className={`text-[10px] w-fit status-indicator ${evaluation.toLowerCase().replace(/\s+/g, "-")}`}>
            {evaluation}
          </span>
        </div>
      ))}
    </div>        
        <Button
          block
          type="default"
          className="w-full mt-2 rounded-xl bg-white text-gray-800"
        >
          View Full Review
        </Button>


    </Card>
  );
};

export default ReviewHistoryCard;
